import React, {  } from 'react';
import styled from '@emotion/styled';
import { ABSENCE_KIND_LETTERS } from '../data/types';
import { getAbsenceKindTitle } from './EditAbsenceDialog';
import { EventBlock, EventLetter } from './AbsenceCalendar';

export const CalendarLegend: React.FC = () => {
  const kinds = Object.keys(ABSENCE_KIND_LETTERS);

  return (
    <LegendContainer>
      {kinds.map((kind) => (
        <LegendItem key={kind}>
          {/* We reuse the exact visual logic from the calendar, wrapped in a static box */}
          <SampleCell>
            <EventBlock 
              kind={kind} 
              isStart={true} 
              isEnd={true}
            >
              <EventLetter>{ABSENCE_KIND_LETTERS[kind]}</EventLetter>
            </EventBlock>
          </SampleCell>
          <LegendLabel>{getAbsenceKindTitle(kind)}</LegendLabel>
        </LegendItem>
      ))}
      
      {/* Show cancelled state example */}
      <LegendItem>
        <SampleCell>
          <EventBlock 
            kind="remote" // Kind doesn't matter when cancelled
            isStart={true} 
            isEnd={true}
            isCancelled={true}
          >
             <EventLetter>{ABSENCE_KIND_LETTERS["remote"]}</EventLetter>
          </EventBlock>
        </SampleCell>
        <LegendLabel>Отменено / Отклонено</LegendLabel>
      </LegendItem>
    </LegendContainer>
  );
};

// --- Styled Components ---

const LegendContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 250px;
`;


const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const SampleCell = styled.div`
  position: relative;
  width: 32px;
  height: 24px;
`;

const LegendLabel = styled.span`
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.7);
`;

